import type { FC } from 'react';

import { Button, Tooltip, Typography } from 'enable-ui';

import { ButtonTransparent, DropdownContent, Item } from './styles';

import { ReactComponent as ActivateIcon } from 'assets/icons/activate.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as InactivateIcon } from 'assets/icons/inactivate.svg';
import { ReactComponent as ThreeDotsIcon } from 'assets/icons/three-dots.svg';
import { ReactComponent as ViewProfileIcon } from 'assets/icons/view-profile.svg';

import type { ButtonIconActionItem, ButtonIconActionProps } from './types';

import { useBoolean } from 'hooks';

export const ButtonIconAction: FC<ButtonIconActionProps> = ({ actions, iconButton }) => {
  const visible = useBoolean(false);

  const renderIcon = (action: ButtonIconActionItem) => {
    if (action.icon) {
      return action.icon;
    }

    switch (action.label) {
      case 'Edit':
        return <EditIcon />;

      case 'Delete':
        return <DeleteIcon />;

      case 'Activate':
        return <ActivateIcon />;

      case 'Inactivate':
        return <InactivateIcon />;

      case 'View profile':
        return <ViewProfileIcon />;

      case 'Remove':
        return <DeleteIcon />;

      case 'Duplicate':
        return <DuplicateIcon />;

      case 'Export':
        return <DownloadIcon />;

      default:
        return null;
    }
  };

  const newActions = actions.filter((action) => action !== null) as ButtonIconActionItem[];

  return (
    <Tooltip
      bg="transparent"
      trigger="click"
      arrow={false}
      placement="bottom"
      content={
        <DropdownContent>
          {newActions.map((action) => {
            return (
              <Item
                key={action.label}
                onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                  event.stopPropagation();
                  !action.disabled && action.onClick();
                  visible.setValue(false);
                }}
                className={action.disabled ? 'disabled' : ''}
              >
                {renderIcon(action)}{' '}
                <Typography style={{ marginLeft: 8, fontSize: '18px', lineHeight: '26px' }}>
                  {action.label}
                </Typography>
              </Item>
            );
          })}
        </DropdownContent>
      }
      visible={visible.value}
      offset={[5, 0]}
      allowHTML
      interactive
      onClickOutside={() => visible.setValue(false)}
    >
      <ButtonTransparent>
        {iconButton ?? (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              visible.setValue((prev) => !prev);
            }}
            placementIcon="left"
            icon={<ThreeDotsIcon />}
            style={{
              width: 32,
              height: 32,
            }}
          />
        )}
      </ButtonTransparent>
    </Tooltip>
  );
};
